import {ViewChild, AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy} from '@angular/core';
import {Chart, ChartOptions, TooltipItem, registerables} from 'chart.js';

Chart.register(...registerables);

@Component({
    selector: 'app-bar-chart',
    templateUrl: './bar-chart.component.html',
    styleUrls: ['./bar-chart.component.css'],
    standalone: false
})
export class BarChartComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('barcanvases', { static: true }) mybarCanvas;
  context: CanvasRenderingContext2D;
  @Input() data: any;
  barchart: Chart;
  options: ChartOptions<'bar'> = {};

  ngOnInit() {
    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true
        },
        tooltip: {
          enabled: true,
          mode: 'nearest',
          intersect: true,
          callbacks: {
            label: (item: TooltipItem<'bar'>) => {
              const value = Number(item.parsed.y);
              const formatted = value.toLocaleString('en-us', {minimumFractionDigits: 2});
              return item.dataset.label === 'Transactions' ? formatted : '$' + formatted;
            }
          }
        }
      },
      scales: {
        x: {
          display: true,
          grid: {
            display: false
          }
        },
        y: {
          display: true,
          grid: {
            display: false
          },
          ticks: {
            callback: (value) => '$ ' + Number(value).toLocaleString('en-us', {minimumFractionDigits: 2}) + ' USD'
          }
        }
      }
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && !changes.data.firstChange) {
      this.render();
    }
  }

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnDestroy(): void {
    if (this.barchart) {
      this.barchart.destroy();
      this.barchart = null;
    }
  }

  private render(): void {
    if (!this.mybarCanvas || !this.mybarCanvas.nativeElement) {
      return;
    }
    this.context = (this.mybarCanvas.nativeElement as HTMLCanvasElement).getContext('2d');
    if (this.barchart) {
      this.barchart.destroy();
    }
    this.barchart = new Chart(this.context, {
      type: 'bar',
      data: this.data || {labels: [], datasets: []},
      options: this.options
    });
  }
}
